import { RootState } from '../../store';
import { SearchDateType, SpacesType, VenueType } from './types';

export const venuesSelector = (state: RootState): VenueType[] => state.venues.venues;
export const currentVenueSelector = (state: RootState): VenueType => state.venues.currentVenue;
export const venueSpacesSelector = (state: RootState): SpacesType[] => state.venues.currentVenue?.Spaces;
export const searchDataSelector = (state: RootState): SearchDateType => state.venues.searchData;
